/* eslint-disable linebreak-style */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpContext,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { CLEAR_CACHE } from 'src/app/middleware/cache/cache.interceptor';
export interface IResponse {
  message: string;
  data?: unknown;
  status: number;
}
type THttpMethod = 'GET' | 'PUT' | 'DELETE' | 'POST';
export interface IPayload {
  method: THttpMethod;
  url: string;
  data?: any;
  params?: any;
  clearCache?: boolean;
  responseType?: any;
}

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  constructor(public http: HttpClient) {}
  request(payload: IPayload): Observable<HttpResponse<any>> {
    const {
      method,
      url,
      data = {},
      params = {},
      clearCache = false,
      responseType
    } = payload;
    const token = localStorage.getItem('token');
    const urlEnv = environment.baseUrl + url;
    return this.http.request(method, urlEnv, {
      body: data,
      responseType: responseType || 'json',
      context: new HttpContext().set(CLEAR_CACHE, clearCache),
      observe: 'response',
      headers: {
        Authorization: `Bearer ${token}`
      },
      params
    });
  }

  refactorResponse(response: HttpResponse<any>): IResponse {
    return {
      message: response.body.message,
      data: response.body.data,
      status: response.status
    };
  }

  refactorErrorResponse(response: HttpErrorResponse): IResponse {
    if (response.status === 401) {
      localStorage.clear();
      location.reload();
    }
    return {
      message: response.error.message,
      status: response.status
    };
  }
}
